import {
  DefaultDOMWebSocketFactory,
  DefaultPromisedWebSocketFactory,
  FullJitterBackoff,
  ReconnectingPromisedWebSocket,
} from 'amazon-chime-sdk-js';
import config from 'config';
import { select, takeEvery } from 'redux-saga/effects';
import * as chimeActions from 'store/chime/chimeActions';
import { setSocketAction } from 'store/message/messageActions';
import { call, put } from 'store/utils';
import * as messageActions from './messageActions';
import {
  chatMessageSaga,
  kickPresenterSaga,
  muteAllSaga,
  muteSaga,
  stopPresenterVideoSaga,
} from './messageSagas';

const { WSS } = config;

export function* sendMessageFlowSaga(action) {
  const key = 'sendMessage';
  yield put(messageActions.initAction({ key }));
  try {
    const { type, payload } = action.payload;
    const { socket, meetingId, externalMeetingId } = yield select(({ message, chime }) => ({
      socket: message.socket,
      meetingId: chime.meetingId,
      externalMeetingId: chime.externalMeetingId,
    }));
    socket.send(
      JSON.stringify({
        message: 'sendmessage',
        data: JSON.stringify({
          type,
          payload,
          ChimeMeetingId: meetingId,
          ExternalMeetingId: externalMeetingId,
        }),
      })
    );
    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}

export function* initializeChatWebsocketsChannelFlowSaga() {
  const key = 'initializeChatWebsocketsChannelFlowSaga';
  yield put(messageActions.successAction({ key }));
  try {
    const {
      meetingId,
      externalMeetingId,
      externalUserId,
      attendeeId,
      joinToken,
      isRecordingUser,
    } = yield select(({ chime, user }) => ({
      meetingId: chime.meetingId,
      externalMeetingId: chime.externalMeetingId,
      externalUserId: chime.externalUserId,
      attendeeId: chime.attendeeId,
      isRecordingUser: user.isRecordingUser,
      joinToken: chime.attendeeId,
    }));
    if (!isRecordingUser) {
      const messagingUrl = `${WSS}?ChimeMeetingId=${meetingId}&ExternalMeetingId=${externalMeetingId}&ExternalUserId=${externalUserId}&AttendeeId=${attendeeId}&JoinToken=${joinToken}`;
      const socket = new ReconnectingPromisedWebSocket(
        messagingUrl,
        [],
        'arraybuffer',
        new DefaultPromisedWebSocketFactory(new DefaultDOMWebSocketFactory()),
        new FullJitterBackoff(1000, 0, 10000)
      );
      yield socket.open(10000);
      yield put(
        setSocketAction({
          socket,
        })
      );
      // const channel = yield call(createEventChannel, socket);
      // while (true) {
      //   const message = yield take(channel);
      //   yield call(recieveMessageSaga, message);
      // }
    }
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}

// function createEventChannel(socket) {
//   return eventChannel((emit) => {
//     socket.addEventListener('message', function (event) {
//       const data = JSON.parse(event.data);

//       emit(data);
//     });
//     return () => {
//       socket.close();
//     };
//   });
// }
export function* recieveMessageFlowSaga(action) {
  const key = 'receiveMessage';
  yield put(messageActions.initAction({ key }));
  try {
    const { message } = action.payload;

    switch (message.type) {
      case 'chat-message':
        yield call(chatMessageSaga, message);

        break;
      case 'mute-all':
        yield call(muteAllSaga, message);
        break;
      case 'mute':
        yield call(muteSaga, message.payload);
        break;
      case 'remove':
        yield call(kickPresenterSaga, message.payload.attendeeId);
        break;

      case 'end-meeting':
        yield put(chimeActions.leaveRoomAction());
        break;
      case 'stop-presenter-video':
        yield call(stopPresenterVideoSaga, message.payload.presenterAttendeeId);
        break;
      // case 'update-host':
      //   newHostId = message.payload.hostId;
      //   yield put(chimeActions.setHostAction({ hostId: newHostId }));
      //   break;
      // case 'raise-hand':
      //   messageAttendeeId = message.payload.attendeeId;
      //   yield put(
      //     chimeActions.updateRosterAttributeAction({
      //       attendeeId: messageAttendeeId,
      //       key: 'raisedHand',
      //       value: { isRaised: true, time: Date.now() },
      //     })
      //   );
      //   if (!popout.open && popout.name !== 'Roster') {
      //     yield put(
      //       utilActions.setNotificationAction({
      //         message: `${message?.payload?.name || 'Someone'} Raised Their Hand`,
      //         type: 'warning',
      //         icon: InfoOutlinedIcon,
      //         notiPopoutName: 'Roster',
      //       })
      //     );
      //   }
      //   break;
      // case 'dismiss-hand':
      //   messageAttendeeId = message.payload.attendeeId;
      //   yield put(
      //     chimeActions.updateRosterAttributeAction({
      //       attendeeId: messageAttendeeId,
      //       key: 'raisedHand',
      //       value: { isRaised: false, time: null },
      //     })
      //   );
      //   if (messageAttendeeId === attendeeId) {
      //     yield put(messageActions.setRaisedHandAction({ raisedHand: false }));
      //   }
      //   break;
      // case 'unmute-all':
      //   if (hostId !== externalUserId) {
      //     yield call(audioVideo.realtimeSetCanUnmuteLocalAudio, true);
      //     yield put(videoActions.setCanUnmuteAction({ canUnmute: false }));
      //     yield call(audioVideo.realtimeMuteLocalAudio);
      //   }
      //   break;

      // case 'setGuestSpeaker':
      //   messageAttendeeId = message.payload.attendeeId;
      //   yield put(videoActions.setGuestSpeakerIdAction(messageAttendeeId));
      //   break;
      // case 'removeGuestSpeaker':
      //   messageAttendeeId = message.payload.attendeeId;
      //   yield put(videoActions.setGuestSpeakerIdAction(null));
      //   break;
      // case 'live-transcript':
      // if (message.payload.messageDate > this.lastRecievedTranscriptDate) {
      //   this.lastRecievedTranscriptDate = message.payload.messageDate
      //   this.transcription = message.payload.speech
      //   this.publishTranscriptionUpdate()
      // }
      // break;
      // case 'transcript-message':
      // if (message.payload.messageDate > this.lastRecievedTranscriptDate) {
      //   this.lastRecievedTranscriptDate = message.payload.messageDate
      //   this.transcription = message.payload.speech
      //   this.publishTranscriptionUpdate()
      // }
      // break;
      default:
        break;
    }
    yield put(messageActions.successAction({ key }));
  } catch (error) {
    yield put(messageActions.errorAction({ key, error }));
  }
}

export default function* chimeMessageWatcher() {
  yield takeEvery(
    chimeActions.startMessagingAction().type,
    initializeChatWebsocketsChannelFlowSaga
  );
  yield takeEvery(messageActions.sendMessageAction().type, sendMessageFlowSaga);
  yield takeEvery(messageActions.receiveMessageAction().type, recieveMessageFlowSaga);
}
